import React, { Component, Fragment } from 'react'
import { FormSubmit } from '@myxplor/forms'
import HeadingRocket from '../heading-rocket'

class ChangePasswordSuccessView extends Component {

  render() {
    return (
      <Fragment>
        <HeadingRocket>Change Password</HeadingRocket>
        <p>Your password has been updated successfully!</p>

        {this.props.returnUrl &&
          <form action={this.props.returnUrl} method="GET">
            <p>Please sign in to continue...</p>
            <FormSubmit>
              Back to Sign In
            </FormSubmit>
          </form>
        }
      </Fragment>
    )
  }

}

export default ChangePasswordSuccessView



// WEBPACK FOOTER //
// ./src/change-password/success.jsx